/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Pending_StuckInputs */

const vi_einvoice_pending_stuck = /** @type {(inputs: Einvoice_Pending_StuckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MISA chưa xác nhận hóa đơn này. Báo quản trị nếu cần gấp.`)
};

/**

* @param {Einvoice_Pending_StuckInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_pending_stuck = /** @type {((inputs?: Einvoice_Pending_StuckInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Pending_StuckInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_pending_stuck(inputs)
});